import {
  allAttachmentsDownload,
  completedContractAttachmentsDownload,
  infomaAttachmentsDownload,
  downloadFileMs,
} from '../../redux/actions/attachments'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { startLoading, doneLoading } from '../../utils/loading'

export const callGetDownloadService = async (projectId, fileObj, type) => {
  startLoading()
  let result
  try {
    var file
    if (fileObj.isCompleted) {
      file = await completedContractAttachmentsDownload(projectId, fileObj.path)
    } else {
      file = await allAttachmentsDownload(projectId, fileObj.path)
    }
    let isEsignature = fileObj.path.includes('esignature')
    let fileName = `${fileObj.fileName || fileObj.id}`
    let _type = `${fileObj.type ? '.' + fileObj.type : ''}`

    if (!isEsignature) {
      fileName = fileName + _type
    }
    if (type == 'download') {
      downloadFile(file, fileName)
    } else {
      previewFile(file, fileName)
    }
  } catch (e) {
    console.log(e)
    result = true
  }
  doneLoading()

  return result
}

export const callInfomaDownloadService = async (projectId, fileObj, type) => {
  startLoading()
  let result
  try {
    var file = await infomaAttachmentsDownload(projectId, fileObj.path)
    if (type == 'download') {
      downloadFile(
        file,
        `${fileObj.fileName || fileObj.id}${fileObj.type ? '.' + fileObj.type : ''}`
      )
    } else {
      previewFile(
        file,
        `${fileObj.fileName || fileObj.id}${fileObj.type ? '.' + fileObj.type : ''}`
      )
    }
  } catch (e) {
    console.log(e)
    result = true
  }
  doneLoading()

  return result
}

export const callGetDownloadFileMs = async (fileObj) => {
  startLoading()
  let result

  try {
    var file = await downloadFileMs(fileObj.path)
    console.log('file ', file)
    if (file) {
      downloadFile(file, `${fileObj.fileName}`)
    } else {
      result = true
    }
  } catch (e) {
    console.log(e)
    result = true
  }

  doneLoading()

  return result
}
